import { createStore } from "redux";

// import { persistStore, persistReducer } from 'redux-persist'
// import storage from 'redux-persist/lib/storage' 

import rootReducer from "./reducers";
import initialState from "./initialState"

// const persistConfig = {
//     key: 'root',
//     storage,
// }

// const persistedReducer = persistReducer(persistConfig, rootReducer)

// let store = createStore(
//     persistedReducer,initialState,
//     window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
// );
// let persistor = persistStore(store);
// window.persistor = persistor;

// export { store, persistor };

let store = createStore(rootReducer, initialState,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export { store };



// WEBPACK FOOTER //
// ./src/store/index.js